import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import fullScreenEnterIcon from '@lifesize/ux-assets/vectors/svgIcons/full-screen-enter.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import classes from './MiniPlayerHeader.module.scss';

const MiniPlayerHeader = props => (
  <div className={classes.container}>
    <div className={classes.draggableTitleStyle}>
      <span>{props.title}</span>
    </div>
    <button className={classes.goBackButton} onClick={props.onGoBackClick}>
      <SVG src={fullScreenEnterIcon} data-testid="fullScreenEnterIcon" />
      <Tooltip
        location="left"
        label={(<FormattedMessage id="components.welcome.returnToCall" />)}
      />
    </button>
  </div >
);

MiniPlayerHeader.propTypes = {
  intl: PT.object,
  title: PT.string,
  onGoBackClick: PT.func
};

export default MiniPlayerHeader;
